module.exports = __webpack_public_path__ + "245d1e1b5f92a772caf58b7daa96eb7b.MP3";